import SvgIcon from "@material-ui/core/SvgIcon";
import AnnouncementIcon from '@material-ui/icons/Announcement';
// import Assessment from "@material-ui/icons/Assessment";
// import RfqImage from "../../assets/RFQ.svg";
// import contractImage from "../../assets/Contract.svg";
// import quotationImage from "../../assets/quotation.svg";
// import jobImage from "../../assets/job.svg";
// import rakeImage from "../../assets/rake.svg";
// import TrainIcon from "@material-ui/icons/Train";
// import DirectionsRailwayIcon from "@material-ui/icons/DirectionsRailway";
// import HowToVoteIcon from "@material-ui/icons/HowToVote";
// import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
// import DescriptionIcon from "@material-ui/icons/Description";
// import AssignmentIcon from "@material-ui/icons/Assignment";
// import ApartmentIcon from "@material-ui/icons/Apartment";
// import Train from "@material-ui/icons/Train";

function Dashboard(props) {
  return (
    <SvgIcon {...props}>
      <g id="Dashboard_icon">
        <g id="Group_2" data-name="Group 2" transform="translate(-24 -6)">
          <g id="dashboard" transform="translate(27 9)">
            <path
              id="Path_23"
              data-name="Path 23"
              d="M27,23.625h1.479v3.7H27Z"
              transform="translate(-13.438 -12.282)"
              fill="#7d9eb5"
            />
            <path
              id="Path_24"
              data-name="Path 24"
              d="M22.5,18h1.479v7.4H22.5Z"
              transform="translate(-11.063 -10.356)"
              fill="#7d9eb5"
            />
            <path
              id="Path_25"
              data-name="Path 25"
              d="M10.448,25.4a3.7,3.7,0,0,1-3.7-3.7H8.229a2.219,2.219,0,1,0,2.219-2.219V18a3.7,3.7,0,0,1,0,7.4Z"
              transform="translate(-3.791 -10.356)"
              fill="#7d9eb5"
            />
            <path
              id="Path_26"
              data-name="Path 26"
              d="M18.964,2.25H3.536A1.287,1.287,0,0,0,2.25,3.536V18.964A1.287,1.287,0,0,0,3.536,20.25H18.964a1.287,1.287,0,0,0,1.286-1.286V3.536A1.287,1.287,0,0,0,18.964,2.25Zm0,5.786h-9v-4.5h9ZM8.679,3.536v4.5H3.536v-4.5ZM3.536,18.964V9.321H18.964v9.643Z"
              transform="translate(-2.25 -2.25)"
              fill="#7d9eb5"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

function HomeRounded(props) {
  return (
    <SvgIcon {...props}>
      <g id="Home_Rounded_Icon">
        <g transform="translate(-24 -24)">
          {/* scale increased from 1 to 1.12 to make the icon a bit bigger */}
          <g transform="translate(26 26) scale(1.12)">
            {/* Rounded background */}
            <rect
              width="20"
              height="20"
              rx="5"
              fill="#eef5fa"
            />

            {/* Home shape */}
            <path
              d="M10 5.2L4.5 9.8V15a1 1 0 001 1H8.5v-3.2a1 1 0 011-1h1a1 1 0 011 1V16h3a1 1 0 001-1V9.8L10 5.2z"
              fill="#7d9eb5"
            />

            {/* Roof */}
            <path
              d="M10 3L3 8.8l1 1.2L10 5l6 5 1-1.2z"
              fill="#7d9eb5"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}


function ExecutiveDashboard(props) {
  return (
    <SvgIcon {...props}>
      <g
        id="data_entry"
        data-name="data entry"
        clip-path="url(#clip-data_entry)"
      >
        <g
          id="Group_76"
          data-name="Group 76"
          transform="translate(-0.5 -1.116)"
        >
          <path
            id="Path_232"
            data-name="Path 232"
            d="M603.665,529.949h-6.209v-1.3H603l-.236-10.138H585.112v10.138h5.216v1.3h-5.866a.65.65,0,0,1-.65-.65V517.861a.65.65,0,0,1,.65-.65H603.4a.65.65,0,0,1,.65.635l.266,11.438a.65.65,0,0,1-.65.665Z"
            transform="translate(-581.962 -512.745)"
            fill="#7d9eb5"
          />
          <path
            id="Polygon_8"
            data-name="Polygon 8"
            d="M6,1.838,3.138,4.7H8.862L6,1.838M6,.207a.5.5,0,0,1,.354.146l4.793,4.793A.5.5,0,0,1,10.793,6H1.207a.5.5,0,0,1-.354-.854L5.646.354A.5.5,0,0,1,6,.207Z"
            transform="translate(6 15)"
            fill="#7d9eb5"
          />
          <path
            id="Line_66"
            data-name="Line 66"
            d="M3,.65H0A.65.65,0,0,1-.65,0,.65.65,0,0,1,0-.65H3A.65.65,0,0,1,3.65,0,.65.65,0,0,1,3,.65Z"
            transform="translate(5 7.5)"
            fill="#7d9eb5"
          />
          <path
            id="Line_67"
            data-name="Line 67"
            d="M8,.65H0A.65.65,0,0,1-.65,0,.65.65,0,0,1,0-.65H8A.65.65,0,0,1,8.65,0,.65.65,0,0,1,8,.65Z"
            transform="translate(10 7.5)"
            fill="#7d9eb5"
          />
          <path
            id="Line_68"
            data-name="Line 68"
            d="M3,.65H0A.65.65,0,0,1-.65,0,.65.65,0,0,1,0-.65H3A.65.65,0,0,1,3.65,0,.65.65,0,0,1,3,.65Z"
            transform="translate(5 10.5)"
            fill="#7d9eb5"
          />
          <path
            id="Line_72"
            data-name="Line 72"
            d="M3,.65H0A.65.65,0,0,1-.65,0,.65.65,0,0,1,0-.65H3A.65.65,0,0,1,3.65,0,.65.65,0,0,1,3,.65Z"
            transform="translate(10 10.5)"
            fill="#7d9eb5"
          />
          <path
            id="Line_73"
            data-name="Line 73"
            d="M3,.65H0A.65.65,0,0,1-.65,0,.65.65,0,0,1,0-.65H3A.65.65,0,0,1,3.65,0,.65.65,0,0,1,3,.65Z"
            transform="translate(15 10.5)"
            fill="#7d9eb5"
          />
          <path
            id="Line_74"
            data-name="Line 74"
            d="M3,.65H0A.65.65,0,0,1-.65,0,.65.65,0,0,1,0-.65H3A.65.65,0,0,1,3.65,0,.65.65,0,0,1,3,.65Z"
            transform="translate(5 13.5)"
            fill="#7d9eb5"
          />
          <path
            id="Line_75"
            data-name="Line 75"
            d="M3,.65H0A.65.65,0,0,1-.65,0,.65.65,0,0,1,0-.65H3A.65.65,0,0,1,3.65,0,.65.65,0,0,1,3,.65Z"
            transform="translate(10 13.5)"
            fill="#7d9eb5"
          />
          <path
            id="Line_76"
            data-name="Line 76"
            d="M3,.65H0A.65.65,0,0,1-.65,0,.65.65,0,0,1,0-.65H3A.65.65,0,0,1,3.65,0,.65.65,0,0,1,3,.65Z"
            transform="translate(15 13.5)"
            fill="#7d9eb5"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
function SalesView(props) {
  return (
    <SvgIcon {...props}>
      <g id="rupee" clip-path="url(#clip-rupee)">
        <g id="Group_79" data-name="Group 79">
          <g id="Group_78" data-name="Group 78" transform="translate(7 5.82)">
            <path
              id="Path_233"
              data-name="Path 233"
              d="M4,8.65V7.35A3.35,3.35,0,0,0,4,.65V-.65a4.65,4.65,0,0,1,0,9.3Z"
              transform="translate(-1.5)"
              fill="#83a3b8"
            />
            <path
              id="Line_70"
              data-name="Line 70"
              d="M10,.65H0V-.65H10Z"
              fill="#83a3b8"
            />
            <path
              id="Line_71"
              data-name="Line 71"
              d="M10,.65H0V-.65H10Z"
              transform="translate(0 4.678)"
              fill="#83a3b8"
            />
            <path
              id="Line_72"
              data-name="Line 72"
              d="M10,.65H0V-.65H10Z"
              fill="#83a3b8"
            />
            <path
              id="Line_73"
              data-name="Line 73"
              d="M8,.65H0V-.65H8Z"
              transform="translate(0.4 7.88) rotate(45)"
              fill="#83a3b8"
            />
            <path
              id="Line_74"
              data-name="Line 74"
              d="M3,.65H0V-.65H3Z"
              transform="translate(0 7.98)"
              fill="#83a3b8"
            />
          </g>
          <path
            id="Ellipse_22"
            data-name="Ellipse 22"
            d="M10,1.3A8.7,8.7,0,1,0,18.7,10,8.71,8.71,0,0,0,10,1.3M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z"
            transform="translate(2 2)"
            fill="#83a3b8"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
function Dsr(props) {
  return (
    <SvgIcon {...props}>
      <g id="DSR_icon">
        <g
          id="Group_9"
          data-name="Group 9"
          transform="translate(-2.142 -225.093) rotate(45)"
        >
          <g id="Group_5" data-name="Group 5" transform="translate(171 151)">
            <line
              id="Line_1"
              data-name="Line 1"
              x2="5.101"
              fill="none"
              stroke="#7d9eb5"
              strokeLinecap="round"
              strokeWidth="1.35"
            />
            <line
              id="Line_2"
              data-name="Line 2"
              x2="5.101"
              transform="rotate(90)"
              fill="none"
              stroke="#7d9eb5"
              strokeLinecap="round"
              strokeWidth="1.35"
            />
          </g>
          <g
            id="Group_6"
            data-name="Group 6"
            transform="translate(179.199 151)"
          >
            <line
              id="Line_1-2"
              data-name="Line 1"
              x1="5.101"
              fill="none"
              stroke="#7d9eb5"
              strokeLinecap="round"
              strokeWidth="1.35"
            />
            <line
              id="Line_2-2"
              data-name="Line 2"
              x2="5.101"
              transform="translate(5.101 0) rotate(90)"
              fill="none"
              stroke="#7d9eb5"
              strokeLinecap="round"
              strokeWidth="1.35"
            />
          </g>
          <g
            id="Group_7"
            data-name="Group 7"
            transform="translate(171 159.199)"
          >
            <line
              id="Line_1-3"
              data-name="Line 1"
              x2="5.101"
              transform="translate(0 5.101)"
              fill="none"
              stroke="#7d9eb5"
              strokeLinecap="round"
              strokeWidth="1.35"
            />
            <line
              id="Line_2-3"
              data-name="Line 2"
              x2="5.101"
              transform="translate(0 5.101) rotate(-90)"
              fill="none"
              stroke="#7d9eb5"
              strokeLinecap="round"
              strokeWidth="1.35"
            />
          </g>
          <g
            id="Group_8"
            data-name="Group 8"
            transform="translate(179.199 159.199)"
          >
            <line
              id="Line_1-4"
              data-name="Line 1"
              x1="5.101"
              transform="translate(0 5.101)"
              fill="none"
              stroke="#7d9eb5"
              strokeLinecap="round"
              strokeWidth="1.35"
            />
            <line
              id="Line_2-4"
              data-name="Line 2"
              x2="5.101"
              transform="translate(5.101 5.101) rotate(-90)"
              fill="none"
              stroke="#7d9eb5"
              strokeLinecap="round"
              strokeWidth="1.35"
            />
          </g>
          <g
            id="Ellipse_1"
            data-name="Ellipse 1"
            transform="translate(174.3 154.3)"
            fill="none"
            stroke="#7d9eb5"
            strokeWidth="1.35"
          >
            <circle cx="3.35" cy="3.35" r="3.35" stroke="none" />
            <circle cx="3.35" cy="3.35" r="2.675" fill="none" />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
function Job(props) {
  return (
    <SvgIcon {...props}>
      <g id="Job_icon">
        <g id="purchase" transform="translate(-0.25 -0.506)">
          <path
            id="Subtraction_1"
            data-name="Subtraction 1"
            d="M-101.179-117.943h-17.142a1.43,1.43,0,0,1-1.429-1.428v-12.164a1.43,1.43,0,0,1,1.429-1.428h17.142a1.43,1.43,0,0,1,1.429,1.428v12.164A1.43,1.43,0,0,1-101.179-117.943Zm-17.142-10.226v8.8h17.142v-7.942l0-3,0-1.223h-17.142v1.939h.009v1.428Z"
            transform="translate(122 139.919)"
            fill="#7d9eb5"
          />
          <path
            id="Path_28"
            data-name="Path 28"
            d="M6.75,22.5H20.111v1.429H6.75Z"
            transform="translate(29.893 0.925) rotate(90)"
            fill="#7d9eb5"
          />
          <path
            id="Path_37"
            data-name="Path 37"
            d="M6.75,22.5H20.111v1.429H6.75Z"
            transform="translate(40.893 0.925) rotate(90)"
            fill="#7d9eb5"
          />
        </g>
        <g
          id="Path_39"
          data-name="Path 39"
          transform="translate(7 2.53)"
          fill="none"
        >
          <path
            d="M2,0H8a2,2,0,0,1,2,2V5.315H0V2A2,2,0,0,1,2,0Z"
            stroke="none"
          />
          <path
            d="M 2 1.29999828338623 C 1.614020347595215 1.29999828338623 1.300000190734863 1.614018440246582 1.300000190734863 1.999998331069946 L 1.300000190734863 4.014958381652832 L 8.699999809265137 4.014958381652832 L 8.699999809265137 1.999998331069946 C 8.699999809265137 1.614018440246582 8.385979652404785 1.29999828338623 8 1.29999828338623 L 2 1.29999828338623 M 2 -1.430511474609375e-06 L 8 -1.430511474609375e-06 C 9.104570388793945 -1.430511474609375e-06 10 0.8954281806945801 10 1.999998331069946 L 10 5.314958095550537 L 0 5.314958095550537 L 0 1.999998331069946 C 0 0.8954281806945801 0.8954296112060547 -1.430511474609375e-06 2 -1.430511474609375e-06 Z"
            stroke="none"
            fill="#7d9eb5"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
function Maintainance(props) {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enable-background="new 0 0 24 24"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="currentColor"
      >
        <g>
          <rect fill="none" height="24" width="24" />
        </g>
        <g>
          <g>
            <path d="M9,15c-2.67,0-8,1.34-8,4v2h16v-2C17,16.34,11.67,15,9,15z M3,19c0.22-0.72,3.31-2,6-2c2.7,0,5.8,1.29,6,2H3z" />
            <path d="M4.74,9H5c0,2.21,1.79,4,4,4s4-1.79,4-4h0.26c0.27,0,0.49-0.22,0.49-0.49V8.49c0-0.27-0.22-0.49-0.49-0.49H13 c0-1.48-0.81-2.75-2-3.45V5.5C11,5.78,10.78,6,10.5,6S10,5.78,10,5.5V4.14C9.68,4.06,9.35,4,9,4S8.32,4.06,8,4.14V5.5 C8,5.78,7.78,6,7.5,6S7,5.78,7,5.5V4.55C5.81,5.25,5,6.52,5,8H4.74C4.47,8,4.25,8.22,4.25,8.49v0.03C4.25,8.78,4.47,9,4.74,9z M11,9c0,1.1-0.9,2-2,2s-2-0.9-2-2H11z" />
            <path d="M21.98,6.23l0.93-0.83l-0.75-1.3l-1.19,0.39c-0.14-0.11-0.3-0.2-0.47-0.27L20.25,3h-1.5L18.5,4.22 c-0.17,0.07-0.33,0.16-0.48,0.27L16.84,4.1l-0.75,1.3l0.93,0.83C17,6.4,17,6.58,17.02,6.75L16.09,7.6l0.75,1.3l1.2-0.38 c0.13,0.1,0.28,0.18,0.43,0.25L18.75,10h1.5l0.27-1.22c0.16-0.07,0.3-0.15,0.44-0.25l1.19,0.38l0.75-1.3l-0.93-0.85 C22,6.57,21.99,6.4,21.98,6.23z M19.5,7.75c-0.69,0-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25s1.25,0.56,1.25,1.25 S20.19,7.75,19.5,7.75z" />
            <path d="M19.4,10.79l-0.85,0.28c-0.1-0.08-0.21-0.14-0.33-0.19L18.04,10h-1.07l-0.18,0.87c-0.12,0.05-0.24,0.12-0.34,0.19 l-0.84-0.28l-0.54,0.93l0.66,0.59c-0.01,0.13-0.01,0.25,0,0.37l-0.66,0.61l0.54,0.93l0.86-0.27c0.1,0.07,0.2,0.13,0.31,0.18 L16.96,15h1.07l0.19-0.87c0.11-0.05,0.22-0.11,0.32-0.18l0.85,0.27l0.54-0.93l-0.66-0.61c0.01-0.13,0.01-0.25,0-0.37l0.66-0.59 L19.4,10.79z M17.5,13.39c-0.49,0-0.89-0.4-0.89-0.89c0-0.49,0.4-0.89,0.89-0.89s0.89,0.4,0.89,0.89 C18.39,12.99,17.99,13.39,17.5,13.39z" />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
function Masters(props) {
  return (
    <SvgIcon {...props}>
      <g id="Masters_icon" clipPath="url(#clip-Masters_icon)">
        <path
          id="data-vis-1"
          d="M19.382,16.527a2.823,2.823,0,0,0-1.442.4l-2.722-2.723a3.544,3.544,0,0,0,0-3.93l1.818-1.818a2.161,2.161,0,1,0-1.009-1.01L14.21,9.269a3.544,3.544,0,0,0-3.93,0L7.556,6.546a2.823,2.823,0,0,0,.4-1.441A2.855,2.855,0,1,0,5.105,7.961a2.823,2.823,0,0,0,1.442-.4l2.722,2.723a3.544,3.544,0,0,0,0,3.93L6.546,16.932a2.824,2.824,0,0,0-1.441-.4,2.855,2.855,0,1,0,2.855,2.855,2.823,2.823,0,0,0-.4-1.442l2.723-2.722a3.547,3.547,0,0,0,1.251.523v2.345a2.142,2.142,0,1,0,1.428,0V15.741a3.547,3.547,0,0,0,1.251-.523l2.723,2.723a2.823,2.823,0,0,0-.4,1.441,2.855,2.855,0,1,0,2.855-2.855ZM12.244,10.1A2.142,2.142,0,1,1,10.1,12.244,2.142,2.142,0,0,1,12.244,10.1Zm-8.566-5A1.428,1.428,0,1,1,5.105,6.533,1.428,1.428,0,0,1,3.678,5.105Zm1.428,15.7a1.428,1.428,0,1,1,1.428-1.428A1.428,1.428,0,0,1,5.105,20.81Zm14.277,0a1.428,1.428,0,1,1,1.428-1.428A1.428,1.428,0,0,1,19.382,20.81Z"
          transform="translate(-0.244 -0.249)"
          fill="#7d9eb5"
        />
      </g>
    </SvgIcon>
  );
}
function RakeInduction(props) {
  return (
    <SvgIcon {...props}>
      <g id="RakeInduction_icon">
        <g id="applications-settings" transform="translate(2 2.345)">
          <path
            id="Path_40"
            data-name="Path 40"
            d="M4.447,2.25A2.759,2.759,0,1,1,1.688,5.009,2.759,2.759,0,0,1,4.447,2.25Zm0,4.138A1.379,1.379,0,1,0,3.067,5.009,1.379,1.379,0,0,0,4.447,6.388Z"
            transform="translate(-1.688 11.543)"
            fill="#7d9eb5"
          />
          <path
            id="Path_41"
            data-name="Path 41"
            d="M16.259,7.767a2.759,2.759,0,1,1,2.759-2.759A2.759,2.759,0,0,1,16.259,7.767Zm0-4.138a1.379,1.379,0,1,0,1.379,1.379A1.379,1.379,0,0,0,16.259,3.629Z"
            transform="translate(-6.259 11.543)"
            fill="#7d9eb5"
          />
          <path
            id="Path_42"
            data-name="Path 42"
            d="M28.072,2.25a2.759,2.759,0,1,1-2.759,2.759A2.759,2.759,0,0,1,28.072,2.25Zm0,4.138a1.379,1.379,0,1,0-1.379-1.379A1.379,1.379,0,0,0,28.072,6.388Z"
            transform="translate(-10.83 11.543)"
            fill="#7d9eb5"
          />
          <path
            id="Path_43"
            data-name="Path 43"
            d="M4.447,19.017a2.759,2.759,0,1,1,2.759-2.759,2.759,2.759,0,0,1-2.759,2.759Zm0-4.138a1.379,1.379,0,1,0,1.379,1.379,1.379,1.379,0,0,0-1.379-1.379Z"
            transform="translate(-1.688 -6.603)"
            fill="#7d9eb5"
          />
          <path
            id="Path_44"
            data-name="Path 44"
            d="M16.259,19.017a2.759,2.759,0,1,1,2.759-2.759A2.759,2.759,0,0,1,16.259,19.017Zm0-4.138a1.379,1.379,0,1,0,1.379,1.379,1.379,1.379,0,0,0-1.379-1.379Z"
            transform="translate(-6.259 -6.603)"
            fill="#7d9eb5"
          />
          <path
            id="Path_45"
            data-name="Path 45"
            d="M28.072,19.017a2.759,2.759,0,1,1,2.759-2.759A2.759,2.759,0,0,1,28.072,19.017Zm0-4.138a1.379,1.379,0,1,0,1.379,1.379,1.379,1.379,0,0,0-1.379-1.379Z"
            transform="translate(-10.83 -6.603)"
            fill="#7d9eb5"
          />
          <path
            id="Path_46"
            data-name="Path 46"
            d="M28.072,30.267a2.759,2.759,0,1,1,2.759-2.759A2.759,2.759,0,0,1,28.072,30.267Zm0-4.138a1.379,1.379,0,1,0,1.379,1.379A1.379,1.379,0,0,0,28.072,26.129Z"
            transform="translate(-10.83 -24.75)"
            fill="#7d9eb5"
          />
          <path
            id="Path_47"
            data-name="Path 47"
            d="M3.938,30.067H5.317V28.688H3.938Z"
            transform="translate(-2.559 -26.964)"
            fill="#7d9eb5"
          />
          <path
            id="Path_48"
            data-name="Path 48"
            d="M10.688,30.067h1.379V28.688H10.688Z"
            transform="translate(-5.171 -26.964)"
            fill="#7d9eb5"
          />
          <path
            id="Path_49"
            data-name="Path 49"
            d="M17.438,30.067h1.379V28.688H17.438Z"
            transform="translate(-7.783 -26.964)"
            fill="#7d9eb5"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
function RakeMaintenance(props) {
  return (
    <SvgIcon {...props}>
      <g id="RakeMaintenance_icon">
        <g id="Group_4" data-name="Group 4" transform="translate(0 -1.694)">
          <path
            id="settings-outline"
            d="M8.454,6.516a1.517,1.517,0,1,0,1.36,1.36A1.517,1.517,0,0,0,8.454,6.516Zm3.652,1.509a3.658,3.658,0,0,1-.036.493l1.072.84a.256.256,0,0,1,.058.326l-1.014,1.754a.256.256,0,0,1-.311.109l-1.064-.428a.382.382,0,0,0-.36.041,3.9,3.9,0,0,1-.51.3.378.378,0,0,0-.209.288L9.572,12.88a.263.263,0,0,1-.253.217H7.291a.263.263,0,0,1-.253-.21l-.159-1.133a.381.381,0,0,0-.213-.29,3.681,3.681,0,0,1-.509-.3.379.379,0,0,0-.358-.04l-1.064.428a.256.256,0,0,1-.311-.109L3.41,9.692a.256.256,0,0,1,.058-.326l.906-.711a.381.381,0,0,0,.142-.334c-.008-.1-.014-.2-.014-.3s.005-.2.014-.293a.379.379,0,0,0-.144-.33l-.905-.711a.256.256,0,0,1-.057-.325L4.423,4.612A.256.256,0,0,1,4.735,4.5L5.8,4.932a.382.382,0,0,0,.36-.041,3.9,3.9,0,0,1,.51-.3.378.378,0,0,0,.209-.288L7.038,3.17a.263.263,0,0,1,.253-.217H9.319a.263.263,0,0,1,.253.21L9.731,4.3a.381.381,0,0,0,.213.29,3.681,3.681,0,0,1,.509.3.379.379,0,0,0,.358.04L11.875,4.5a.256.256,0,0,1,.311.109L13.2,6.359a.256.256,0,0,1-.058.326l-.906.711a.381.381,0,0,0-.143.334c.008.1.013.2.013.3Z"
            transform="translate(8.209 7.741)"
            fill="none"
            stroke="#7d9eb5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          />
          <rect
            id="Rectangle_1"
            data-name="Rectangle 1"
            width="20"
            height="1.389"
            rx="0.694"
            transform="translate(2 6)"
            fill="#7d9eb5"
          />
          <rect
            id="Rectangle_2"
            data-name="Rectangle 2"
            width="8.444"
            height="1.389"
            rx="0.694"
            transform="translate(2 13)"
            fill="#7d9eb5"
          />
          <rect
            id="Rectangle_3"
            data-name="Rectangle 3"
            width="7.222"
            height="1.389"
            rx="0.694"
            transform="translate(2 20)"
            fill="#7d9eb5"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
function WagonDamage(props) {
  return (
    <SvgIcon {...props}>
      <g id="WagonDamage_icon">
        <g
          id="Group_3"
          data-name="Group 3"
          transform="translate(-133 -142.038)"
        >
          <g id="box-seam" transform="translate(135 144.173)">
            <path
              id="Path_35"
              data-name="Path 35"
              d="M10.233,1.468a.625.625,0,0,0-.465,0L2.308,4.452l3,1.2,7.692-3.076ZM14.688,3.25,6.995,6.327,10,7.528l7.692-3.076-3.005-1.2Zm4.063,2.125-8.125,3.25v9.9l8.125-3.25v-9.9ZM9.375,18.529V8.624L1.25,5.376v9.9ZM9.3.307a1.875,1.875,0,0,1,1.393,0l8.911,3.565a.625.625,0,0,1,.392.58V15.279a1.25,1.25,0,0,1-.786,1.16l-8.981,3.592a.625.625,0,0,1-.465,0L.787,16.439A1.25,1.25,0,0,1,0,15.279V4.452a.625.625,0,0,1,.393-.58Z"
              transform="translate(0 -0.173)"
              fill="#7d9eb5"
              fillRule="evenodd"
            />
          </g>
          <path
            id="Path_36"
            data-name="Path 36"
            d="M135.5,158.774l1.683,2.244,2.27-1.654,2.059,4.859,2.534-1.333-2.9,4-2.059-3.746-1.9,1.451-1.92-2.143Z"
            transform="translate(-0.253 -6.936)"
            fill="#7d9eb5"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
function ReportsIcon(props) {
  return (
    <SvgIcon {...props}>
      <g
        id="icon_role_16"
        data-name="icon_role – 16"
        clipPath="url(#clip-icon_role_16)"
      >
        <g id="Group_28" data-name="Group 28" transform="translate(0 -0.974)">
          <g id="Group_27" data-name="Group 27" transform="translate(-2 -2)">
            <g id="Group_26" data-name="Group 26">
              <path
                id="Path_208"
                data-name="Path 208"
                d="M7.5,7.625h-4V6.375h4a2.875,2.875,0,0,0,0-5.75H6.509V-.625H7.5a4.125,4.125,0,0,1,0,8.25Z"
                transform="translate(12 10)"
                fill="#7d9eb5"
              />
              <path
                id="Path_209"
                data-name="Path 209"
                d="M7.5,5.7h-4V4.453h4c1.558,0,2.875-.876,2.875-1.914S9.058.625,7.5.625h-4V-.625h4a4.86,4.86,0,0,1,2.842.863,2.845,2.845,0,0,1,1.283,2.3,2.845,2.845,0,0,1-1.283,2.3A4.86,4.86,0,0,1,7.5,5.7Z"
                transform="translate(22 17) rotate(180)"
                fill="#7d9eb5"
              />
              <path
                id="Path_210"
                data-name="Path 210"
                d="M9.5,3.052H5.808a.587.587,0,0,1-.625-.539.587.587,0,0,1,.625-.539H9.5c1.145,0,1.875-.451,1.875-.761S10.312.537,9.168.537c-.345,0-.293-.326-.293-.624A.587.587,0,0,1,9.5-.625c1.752,0,3.125.808,3.125,1.839S11.252,3.052,9.5,3.052Z"
                transform="translate(8.75 11.922)"
                fill="#7d9eb5"
              />
            </g>
          </g>
          <path
            id="Path_208-2"
            data-name="Path 208"
            d="M16.714,14.625H1.286c-1.089,0-1.911-.6-1.911-1.4V.778H.625v12.4a.991.991,0,0,0,.661.194H16.714a.991.991,0,0,0,.661-.194V.819a.991.991,0,0,0-.661-.194h-5.2V-.625h5.2c1.089,0,1.911.6,1.911,1.4V13.222C18.625,14.022,17.8,14.625,16.714,14.625Z"
            transform="translate(17 4) rotate(90)"
            fill="#7d9eb5"
          />
          <path
            id="Path_209-2"
            data-name="Path 209"
            d="M16.714,14.625H12.341v-1.25h4.374a.96.96,0,0,0,.7-.228.131.131,0,0,0-.013.06h1.25C18.651,14,17.8,14.625,16.714,14.625Z"
            transform="translate(3 22) rotate(-90)"
            fill="#7d9eb5"
          />
          <path
            id="Line_28"
            data-name="Line 28"
            d="M9,.625H0A.625.625,0,0,1-.625,0,.625.625,0,0,1,0-.625H9A.625.625,0,0,1,9.625,0,.625.625,0,0,1,9,.625Z"
            transform="translate(5.5 19.399)"
            fill="#7d9eb5"
          />
          <path
            id="Line_29"
            data-name="Line 29"
            d="M9,.625H0A.625.625,0,0,1-.625,0,.625.625,0,0,1,0-.625H9A.625.625,0,0,1,9.625,0,.625.625,0,0,1,9,.625Z"
            transform="translate(5.5 6.817)"
            fill="#7d9eb5"
          />
          <path
            id="Line_28-2"
            data-name="Line 28"
            d="M5.55.625H-.224c-.221,0-.4-.28-.4-.625s.18-.625.4-.625H5.55c.221,0,.4.28.4.625S5.771.625,5.55.625Z"
            transform="translate(5.5 16.817)"
            fill="#7d9eb5"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
function RebateInvoiceReports(props) {
  return (
    <SvgIcon {...props}>
      <g id="reports_icon">
        <g id="reports" transform="translate(-13.817 -2.024)">
          <path
            id="Path_86"
            data-name="Path 86"
            d="M33.21,7.908c0-.013-.006-.025-.009-.038a.378.378,0,0,0-.013-.04c-.005-.013-.011-.025-.017-.037a.327.327,0,0,0-.045-.071c-.005-.007-.009-.014-.015-.021L29.989,4.165l-.009-.009a.408.408,0,0,0-.032-.03l-.03-.025-.033-.021a.34.34,0,0,0-.036-.02l-.036-.013c-.012,0-.027-.009-.04-.013l-.036-.006-.046,0H19.568a1.753,1.753,0,0,0-1.751,1.751v16.5a1.753,1.753,0,0,0,1.751,1.751h11.9a1.753,1.753,0,0,0,1.751-1.751V7.978c0-.009,0-.017,0-.025a.4.4,0,0,0,0-.045ZM30.093,5.542l1.783,2.018H30.093Zm2.291,16.731a.918.918,0,0,1-.917.917h-11.9a.918.918,0,0,1-.917-.917V5.775a.918.918,0,0,1,.917-.917h9.692v3.12a.417.417,0,0,0,.417.417h2.708Z"
            transform="translate(0 0)"
            fill="#7d9eb5"
            stroke="#7d9eb5"
            stroke-width="0.1"
          />
          <path
            id="Path_87"
            data-name="Path 87"
            d="M44.87,104.123H36.3a.415.415,0,1,0,0,.829H44.87a.415.415,0,1,0,0-.829Z"
            transform="translate(-15.067 -83.392)"
            fill="#7d9eb5"
            stroke="#7d9eb5"
            stroke-width="0.1"
          />
          <path
            id="Path_88"
            data-name="Path 88"
            d="M59.461,72.992a.415.415,0,0,0,.415-.415V68.815a.415.415,0,0,0-.415-.415H57.8a.415.415,0,0,0-.415.415v3.762a.415.415,0,0,0,.415.415Zm-1.242-3.762h.827v2.933h-.827Z"
            transform="translate(-32.968 -53.626)"
            fill="#7d9eb5"
            stroke="#7d9eb5"
            stroke-width="0.1"
          />
          <path
            id="Path_89"
            data-name="Path 89"
            d="M79.108,60.684a.415.415,0,0,0,.415-.415V54.06a.415.415,0,0,0-.415-.415H77.452a.415.415,0,0,0-.415.415v6.21a.415.415,0,0,0,.415.415Zm-1.242-6.21h.827v5.381h-.827Z"
            transform="translate(-49.336 -41.325)"
            fill="#7d9eb5"
            stroke="#7d9eb5"
            stroke-width="0.1"
          />
          <path
            id="Path_90"
            data-name="Path 90"
            d="M38.156,79.648h1.657a.415.415,0,0,0,.415-.415V76.795a.415.415,0,0,0-.415-.415H38.156a.415.415,0,0,0-.415.415v2.439A.415.415,0,0,0,38.156,79.648Zm.415-2.439H39.4v1.609H38.57Z"
            transform="translate(-16.599 -60.28)"
            fill="#7d9eb5"
            stroke="#7d9eb5"
            stroke-width="0.1"
          />
          <path
            id="Path_91"
            data-name="Path 91"
            d="M42.291,37.219a1.288,1.288,0,0,0,.051.356,11.911,11.911,0,0,1-1.283.99,1.318,1.318,0,0,0-1.557-.247,1.3,1.3,0,0,0-.669,1.417c-.339.134-.684.254-1.033.357a1.314,1.314,0,0,0-1.562-.653,1.3,1.3,0,1,0,1.681,1.481,12.842,12.842,0,0,0,1.347-.464,1.317,1.317,0,0,0,1.467.163,1.3,1.3,0,0,0,.688-1.3,12.765,12.765,0,0,0,1.4-1.062,1.318,1.318,0,0,0,1.624-.051,1.292,1.292,0,0,0,.325-1.579,1.312,1.312,0,0,0-2.479.587ZM36.63,41.149a.471.471,0,1,1,.476-.471A.473.473,0,0,1,36.63,41.149Zm3.486-1.21a.471.471,0,1,1,.475-.471A.473.473,0,0,1,40.116,39.938Zm3.962-2.719a.475.475,0,1,1-.475-.471.473.473,0,0,1,.475.471Z"
            transform="translate(-14.599 -26.565)"
            fill="#7d9eb5"
            stroke="#7d9eb5"
            stroke-width="0.1"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
function Invoice(props) {
  return (
    <SvgIcon {...props}>
      <g id="Invoice_Icon" transform="translate(0 0)">
        <path
          d="M4 2H16C16.55 2 17 2.45 17 3V21L14 19L11 21L8 19L5 21L2 19V3C2 2.45 2.45 2 3 2H4Z"
          fill="#7d9eb5"
        />
        <rect x="5" y="5" width="9" height="1.5" fill="#FFFFFF" />
        <rect x="5" y="9" width="6" height="1.5" fill="#FFFFFF" />
        <rect x="5" y="13" width="3" height="1.5" fill="#FFFFFF" />
      </g>
    </SvgIcon>
  );
}

function Maintenance(props) {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enable-background="new 0 0 24 24"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="currentColor"
      >
        <g>
          <rect fill="none" height="24" width="24" />
        </g>
        <g>
          <g>
            <path
              d="M9,15c-2.67,0-8,1.34-8,4v2h16v-2C17,16.34,11.67,15,9,15z M3,19c0.22-0.72,3.31-2,6-2c2.7,0,5.8,1.29,6,2H3z"
              stroke="none"
              fill="#7d9eb5"
            />
            <path
              d="M4.74,9H5c0,2.21,1.79,4,4,4s4-1.79,4-4h0.26c0.27,0,0.49-0.22,0.49-0.49V8.49c0-0.27-0.22-0.49-0.49-0.49H13 c0-1.48-0.81-2.75-2-3.45V5.5C11,5.78,10.78,6,10.5,6S10,5.78,10,5.5V4.14C9.68,4.06,9.35,4,9,4S8.32,4.06,8,4.14V5.5 C8,5.78,7.78,6,7.5,6S7,5.78,7,5.5V4.55C5.81,5.25,5,6.52,5,8H4.74C4.47,8,4.25,8.22,4.25,8.49v0.03C4.25,8.78,4.47,9,4.74,9z M11,9c0,1.1-0.9,2-2,2s-2-0.9-2-2H11z"
              stroke="none"
              fill="#7d9eb5"
            />
            <path
              d="M21.98,6.23l0.93-0.83l-0.75-1.3l-1.19,0.39c-0.14-0.11-0.3-0.2-0.47-0.27L20.25,3h-1.5L18.5,4.22 c-0.17,0.07-0.33,0.16-0.48,0.27L16.84,4.1l-0.75,1.3l0.93,0.83C17,6.4,17,6.58,17.02,6.75L16.09,7.6l0.75,1.3l1.2-0.38 c0.13,0.1,0.28,0.18,0.43,0.25L18.75,10h1.5l0.27-1.22c0.16-0.07,0.3-0.15,0.44-0.25l1.19,0.38l0.75-1.3l-0.93-0.85 C22,6.57,21.99,6.4,21.98,6.23z M19.5,7.75c-0.69,0-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25s1.25,0.56,1.25,1.25 S20.19,7.75,19.5,7.75z"
              stroke="none"
              fill="#7d9eb5"
            />
            <path
              d="M19.4,10.79l-0.85,0.28c-0.1-0.08-0.21-0.14-0.33-0.19L18.04,10h-1.07l-0.18,0.87c-0.12,0.05-0.24,0.12-0.34,0.19 l-0.84-0.28l-0.54,0.93l0.66,0.59c-0.01,0.13-0.01,0.25,0,0.37l-0.66,0.61l0.54,0.93l0.86-0.27c0.1,0.07,0.2,0.13,0.31,0.18 L16.96,15h1.07l0.19-0.87c0.11-0.05,0.22-0.11,0.32-0.18l0.85,0.27l0.54-0.93l-0.66-0.61c0.01-0.13,0.01-0.25,0-0.37l0.66-0.59 L19.4,10.79z M17.5,13.39c-0.49,0-0.89-0.4-0.89-0.89c0-0.49,0.4-0.89,0.89-0.89s0.89,0.4,0.89,0.89 C18.39,12.99,17.99,13.39,17.5,13.39z"
              stroke="none"
              fill="#7d9eb5"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
function SFTOReconciliation(props) {
  return (
    <SvgIcon {...props}>
      <g id="SFTOReconciliation">
        <path
          id="Path_29"
          data-name="Path 29"
          d="M22.5,6.75h7.257V8.2H22.5Z"
          transform="translate(-7.012 -0.799)"
          fill="#7d9eb5"
        />
        <path
          id="Path_30"
          data-name="Path 30"
          d="M22.5,13.5h5.08v1.451H22.5Z"
          transform="translate(-7.012 -3.194)"
          fill="#7d9eb5"
        />
        <path
          id="Path_31"
          data-name="Path 31"
          d="M22.5,20.25h7.257V21.7H22.5Z"
          transform="translate(-7.012 -5.59)"
          fill="#7d9eb5"
        />
        <path
          id="Path_32"
          data-name="Path 32"
          d="M22.5,27h5.08v1.451H22.5Z"
          transform="translate(-7.012 -7.986)"
          fill="#7d9eb5"
        />
        <path
          id="Path_33"
          data-name="Path 33"
          d="M15.75,4.5H17.2V21.917H15.75Z"
          transform="translate(-4.616)"
          fill="#7d9eb5"
        />
        <path
          id="Path_34"
          data-name="Path 34"
          d="M3.768,19.323l-1.023-1L7.309,13.88,2.745,9.439l1.023-1,5.6,5.443-5.6,5.443Z"
          transform="translate(0 -1.398)"
          fill="#7d9eb5"
        />
      </g>
    </SvgIcon>
  );
}

let exportIcons = {
  Dashboard,
  ExecutiveDashboard,
  SalesView,
  Dsr,
  Job,
  Maintainance,
  Masters,
  RakeInduction,
  RakeMaintenance,
  WagonDamage,
  ReportsIcon,
  RebateInvoiceReports,
  Invoice,
  Maintenance,
  SFTOReconciliation,
  AnnouncementIcon,
  HomeRounded,
};

export default exportIcons;
